import { useState } from "react";

import Button from "@/components/Atoms/Button";
import SVGSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

import DownloadPDFModal from "./DownloadPDFModal";

import { classNameGenerator, clsx } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./DownloadPDFStrip.module.scss";

interface DownloadPDFStripProps {
  variant?: string;
}

const DownloadPDFStrip: React.FC<DownloadPDFStripProps> = ({
  variant = "",
}) => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { title, ctaText, campaignSlug, formData } = data?.downloadPDF || {};

  const [openDownloadPDFModal, setOpenDownloadPDFModal] = useState(false);

  if (!campaignSlug) {
    return <></>;
  }

  return (
    <section className={clsx(cls("downloadPDFStrip"), cls(variant))}>
      <div className={cls("container")}>
        <div className={cls("leftSection")}>
          <Typography
            variant="heading3"
            className={cls("title")}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
        <div className={cls("rightSection")}>
          <Button
            variant="primary"
            className={cls("actionButton")}
            onClick={() => setOpenDownloadPDFModal(true)}
          >
            <SVGSprite icon="icon-download-pdf-light" className={cls("icon")} />
            {ctaText}
          </Button>
        </div>
      </div>
      {openDownloadPDFModal && (
        <DownloadPDFModal
          title={title}
          onClose={() => setOpenDownloadPDFModal(false)}
          campaignSlug={campaignSlug}
          {...formData}
        />
      )}
    </section>
  );
};

export default DownloadPDFStrip;
